import { render } from "./backgroundSelView.vue?vue&type=template&id=a328b576&scoped=true&ts=true"
import script from "./backgroundSelView.vue?vue&type=script&lang=ts"
export * from "./backgroundSelView.vue?vue&type=script&lang=ts"

import "./backgroundSelView.vue?vue&type=style&index=0&id=a328b576&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a328b576"]])

export default __exports__